import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { Globals } from '../globals';
import { PermisoService } from './permiso.service';
import { Observable } from 'rxjs/Observable';
import { Cotizacion } from '../interfaces/cotizacion';
import { ArchivoCotizacion } from '../interfaces/archivo-cotizacion';
import { GeneralService } from './general.service';

@Injectable()
export class CotizacionService {
  readonly ESTADO_VENDIDA: number = 4;
  readonly ESTADO_AUTORIZADA: number = 7;
  readonly ESTADO_VENTA_ACEPTADA: number = 9;
  readonly ESTADO_VENTA_RECHAZADA: number = 10;

  constructor(
    private http: HttpInterceptor,
     private globals: Globals,
        private general: GeneralService,
    private permisoService: PermisoService
  ) { }

  crearCotizacion(cotizacion: Cotizacion): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-CREAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              cotizacion: cotizacion,
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarCotizacion(cotizacion: Cotizacion): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              cotizacion: cotizacion
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  eliminarCotizacion(IdCotizacion: number): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              IdCotizacion: IdCotizacion
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getTiposCotizacion(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'descripcion',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('TIPOS-COTIZACION-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getCotizaciones(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'fechaAlta',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-VER')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          )
          .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
            (respuesta: Response) => respuesta.json()
          );
      });
  }

  getCotizacionItems(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: 'label',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('ITEM-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getEstadosCotizacion(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: null,
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('ESTADOS-COTIZACION-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getTiposFacturacion(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: null,
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiCotizacion/getTiposFacturacion',
        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
          paginado: paginado,
          orden: orden,
          filtros: filtros
        })
      ).map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  subirArchivosCotizacion(IdCotizacion: number | string, archivos: ArchivoCotizacion[]): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-ARCHIVO-GUARDAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              IdCotizacion: IdCotizacion,
              archivos: archivos
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getArchivosCotizacion(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: 'orden',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction('COTIZACION-ARCHIVOS-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  eliminarArchivoCotizacion(IdArchivo: number | string): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-ARCHIVOS-ELIMINAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              IdArchivo: IdArchivo
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  editarArchivoCotizacion(archivo: ArchivoCotizacion): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-ARCHIVOS-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              archivo: archivo
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  enviarEmailCotizacion(
    asunto: string,
    destinatarios: string[],
    cuerpo: string,
    firma: string,
    pdf: string,
    footer: string,
    IdCotizacion: string,
    IdFormateado: string
  ): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-EMAIL')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              email: {
                asunto: asunto,
                destinatarios: destinatarios,
                cuerpo: cuerpo,
                firma: firma,
                pdf: pdf,
                footer: footer,
                IdCotizacion: IdCotizacion,
                IdFormateado: IdFormateado,
              }
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  descargarPdfCotizacion(
    pdf: string,
    footer: string,
    IdCotizacion: string,
    IdFormateado: string,
  ): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-PDF')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              info: {
                pdf: pdf,
                footer: footer,
                IdCotizacion: IdCotizacion,
                IdFormateado: IdFormateado,
              }
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getObras(): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-VER-OBRAS')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente:localStorage.getItem('idCliente')
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getEstadoDescripciones(): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-VER-ESTADO-DESCRIPCION')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({idCliente:localStorage.getItem('idCliente')})
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  setCotizacionAutorizada(IdCotizacion: number | string): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-AUTORIZAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              IdCotizacion: IdCotizacion
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }


  getTiposMostrarPrecio(): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-ITEM-VER-TIPOS-MOSTRAR-PRECIO')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({idCliente:localStorage.getItem('idCliente')})
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  /**
   * Retorna true si el número esta disponible para la cotización o false si ya está en uso
   */
  validarNumeroDisponible(cotizacion: Cotizacion): Observable<any> {
    return this.permisoService.getPermisoAction('COTIZACION-VALIDAR-NUMERO')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              cotizacion: cotizacion
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  /**
   * modificar asignación de archivos de las operaciones de venta
   */
  asignarArchivosOV(model) {
    model['idCliente']=localStorage.getItem('idCliente');
    return this.permisoService.getPermisoAction('ORDEN-VENTA-ASIGNAR-ARCHIVOS')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify(model)
          );
      })
      .map(
        (respuesta: Response) => respuesta.json());
  }

  guardarOrdenVenta(model, action) {
    model['idCliente']=localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiOrdenVenta/' + action,
        JSON.stringify(model)
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  getOrdenesVenta(
    paginado: any = {
      page: null,
      pageSize: null
    },
    orden: any = {
      sort: 'fecha_alta',
      order: 'desc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiOrdenVenta/getOrdenesVenta',
        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
          paginado: paginado,
          orden: orden,
          filtros: filtros
        })
      ).map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  solicitarAceptacion(model) {
    model['idCliente']=localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiOrdenVenta/solicitarAceptacion',
        JSON.stringify(model)
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  cambiarEstado(model) {
    model['idCliente']=localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiOrdenVenta/cambiarEstado',
        JSON.stringify(model)
      ).map(
        (respuesta: Response) => respuesta.json());
  }
}